<h3 *ngIf="showTitle">{{getString('cookieSettings')}}</h3>

{{getString('cookieSettingsText')}}
<a [routerLink]="'/' + getCountry() + '/' + getString('privacyPolicyUrl')" target="_blank">{{getString('privacyPolicy')}}</a>.

<div class="settings-box">
    <app-toggle-switch [enabled]="false" [layout]="2" [label]="getString('essentials')" [subtitle]="getString('essentialsOnlyText')" [checked]="true"></app-toggle-switch>
    <app-toggle-switch [layout]="2" [label]="getString('googleServices')" [subtitle]="getString('googleServicesText')" [checked]="googleServicesON" (onChange)="googleServicesON = $event"></app-toggle-switch>
</div>

<div class="btn-container">
    <button type="button" (click)="save()" class="black-button">{{getString('save2')}}</button>
    <button type="button" (click)="essentials()" class="button">{{getString('essentialsOnly')}}</button>
    <button type="button" (click)="accept()" class="blue-button">{{getString('acceptAll')}}</button>
</div>